import { supplyConfigAxios } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const supplierUpdateProfile = async (payload, supplierId) => {
    const api = supplyConfigAxios();
    await api.patch(ENDPOINTS.SUPPLIER_SIGNUP_COMPLEMENT + supplierId + '/', payload);
};

export const getPublicDocuments = async supplierId => {
    const api = supplyConfigAxios();
    const { data } = await api.get(`${ENDPOINTS.CONTRACTOR_PUBLIC_DOCUMENTS}${supplierId}/`);
    return data;
};

export const postPublicDocuments = async data => {
    const api = supplyConfigAxios();
    await api.post(ENDPOINTS.REQUEST_PUBLIC_DOCUMENTS, data);
};
